import * as d3 from "d3";
import {
    axisTextDim1, colonAnnotation,
    inrFormatter, numberFormat,
    responsivefy,
    // XaxisAttribute,
} from '../functions'

export default function (chart, divId, vizName, resData) {

    var size = chart.axisFontSize;
    var fontSize = size + "px";
    var fontColor = chart.axisFontColor;
    var axisLabelFontSize = chart.axisLabelFontSize + "px";
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName;

    // axios.post(url, filterParam).then(res => {
        let data = resData
        console.log(data);

        data.forEach(function (d) {
            d.metric1 = +d.metric1;
        });

        var x1Scale = d3.scaleBand().rangeRound([0, chart.width]).padding(0.1);
        var y2Scale = Math.max(
            Math.abs(d3.min(data, (d) => d.metric1)),
            Math.abs(d3.max(data, (d) => d.metric1))
        );

        var y1Scale = d3.scaleLinear().domain([-y2Scale, y2Scale]).rangeRound([chart.height, 0]).nice();
        var x1AxisLabel = d3.axisBottom().scale(x1Scale);
        var y1AxisLabel = d3.axisLeft().scale(y1Scale).tickFormat(inrFormatter);

        var div = d3.select(divId)
            .append('div')
            .attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;');

        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append("svg")
            .attr("width", chart.width + 2 * chart.margin.left + chart.margin.right)
            .attr("height", chart.height + 5 * chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append("g")
            .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

        x1Scale.domain(data.map((d) => d.dim2_name));
        y1Scale.domain([Math.min(0, d3.min(data, d => d.metric1)), Math.max(0, d3.max(data, d => d.metric1))]);

        // x axis label
        svg.append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(x1AxisLabel)
            .selectAll('.tick text')
            .style('text-anchor', 'end') // Adjust text-anchor to 'end'
            .attr('dx', '-.8em') // Adjust horizontal spacing
            .attr('dy', '-.15em') // Adjust vertical spacing
            .attr('transform', 'rotate(-45)') // Rotate the labels for better visibility
            .attr('font-size', '13px') // You can set font-size here if needed
            .text(axisTextDim1);


        svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height + chart.margin.bottom + 2 * chart.axisLabelDistance)
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.x1AxisDisplayName);

        // y axis label
        svg.append("g")
            .attr("class", "y axis")
            .call(y1AxisLabel)
            .style("font-size", axisLabelFontSize);

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left + 2)
            .attr('x', 0 - (chart.height / 2) + 120)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.y1AxisDisplayName);

        // Add circles
        svg.selectAll("circle")
            .data(data)
            .enter()
            .append("circle")
            .attr("cx", d => x1Scale(d.dim2_name) + x1Scale.bandwidth() / 2)
            .attr("cy", d => y1Scale(d.metric1))
            .attr("r", 5)
            .on("mouseover", function (d) {
                // Show tooltip on mouseover
                div.transition()
                    .duration(200)
                    .style("opacity", .9)

                div.html(chart.x1MetricTooltip + colonAnnotation + d.dim2_name
                    + '<br>' + chart.x2MetricTooltip + colonAnnotation + d.dim1_name
                    + '<br>' + chart.y1MetricTooltip + colonAnnotation + numberFormat(d.metric1))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                // Hide tooltip on mouseout
                div.transition()
                    .duration(500)
                    .style("opacity", 0);
            });

        var line = d3.line()
            .x(d => x1Scale(d.dim2_name) + x1Scale.bandwidth() / 2)
            .y(d => y1Scale(d.metric1));

        svg.append("path")
            .data([data])
            .attr("class", "line")
            .attr("d", line)
            .style("stroke", "steelblue")
            .style("fill", "none");

    // })
}